let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hvGeE"), load("jHT17")]).then(() => parcelRequire('8ctJl'));